import { AxiosResponse } from 'axios';

import axiosInstance, { googleFontsAxiosInstance } from 'api/base';
import { TObject } from 'utils/types';

import {
  normalizeActiveTheme,
  normalizeGoogleFont,
  normalizeMerchant,
  normalizeTheme,
} from './normalizers';
import {
  IActivateThemePayload,
  IActiveTheme,
  ICreateThemePayload,
  IDeleteThemePayload,
  IGoogleFont,
  IMerchant,
  ITheme,
  IUpdateThemePayload,
} from './types';

const merchantTerminalThemesAPI = {
  async getThemes(id: string): Promise<IMerchant> {
    const result = await axiosInstance.get(
      `customizations/merchants/terminals/${id}/themes`,
    );
    // const result = await customizationInstance.get(`merchant-terminals/${id}/themes`);

    return normalizeMerchant(result.data);
  },

  async createTheme({ id, theme }: ICreateThemePayload): Promise<ITheme> {
    const {
      amplitudeApiKey,
      clientMinAge,
      currencyPosition,
      hideLogo,
      hideShopTitle,
      inputSeparators,
      isCompactMode,
      isFullIframeMode,
      isPciDssLogo,
      microsoftClarityId,
      name,
      paymentInfoLayout,
      preview,
      textSeparators,
      ...restTheme
    } = theme;
    const { data } = await axiosInstance.post(
      `customizations/merchants/terminals/${id}/themes`,
      {
        amplitudeApiKey,
        clientMinAge,
        currencyPosition,
        hideLogo,
        hideShopTitle,
        inputSeparators,
        isCompactMode,
        isFullIframeMode,
        isPciDssLogo,
        microsoftClarityId,
        name,
        paymentInfoLayout,
        preview,
        textSeparators,
        theme: restTheme,
      },
    );
    // const { data } = await customizationInstance.post(
    //   `merchant-terminals/${id}/themes`,
    //   {
    //     inputSeparators,
    //     isCompactMode,
    //     isFullIframeMode,
    //     isPciDssLogo,
    //     microsoftClarityId,
    //     amplitudeApiKey,
    //     name,
    //     paymentInfoLayout,
    //     preview,
    //     textSeparators,
    //     theme: restTheme,
    //   },
    // );

    return normalizeTheme(data);
  },

  async updateTheme({ id, theme }: IUpdateThemePayload): Promise<ITheme> {
    const {
      amplitudeApiKey,
      clientMinAge,
      currencyPosition,
      hideLogo,
      hideShopTitle,
      id: themeId,
      inputSeparators,
      isCompactMode,
      isFullIframeMode,
      isPciDssLogo,
      isSystem: _isSystem,
      microsoftClarityId,
      name,
      paymentInfoLayout,
      preview,
      textSeparators,
      ...restTheme
    } = theme;
    const { data } = await axiosInstance.put(
      `customizations/merchants/terminals/${id}/themes/${themeId}`,
      {
        amplitudeApiKey,
        clientMinAge,
        currencyPosition,
        hideLogo,
        hideShopTitle,
        inputSeparators,
        isCompactMode,
        isFullIframeMode,
        isPciDssLogo,
        microsoftClarityId,
        name,
        paymentInfoLayout,
        preview,
        textSeparators,
        theme: restTheme,
      },
    );
    // const { data } = await customizationInstance.put(
    //   `merchant-terminals/${id}/themes/${themeId}`,
    //   {
    //     inputSeparators,
    //     isCompactMode,
    //     isFullIframeMode,
    //     isPciDssLogo,
    //     microsoftClarityId,
    //     amplitudeApiKey,
    //     name,
    //     paymentInfoLayout,
    //     preview,
    //     textSeparators,
    //     theme: restTheme,
    //   },
    // );

    return normalizeTheme(data);
  },

  async setActiveTheme({ id, themeId }: IActivateThemePayload): Promise<AxiosResponse> {
    const result = await axiosInstance.put(
      `customizations/merchants/terminals/${id}/themes`,
      {
        themeId,
      },
      { params: { active: true } },
    );
    // const result = await customizationInstance.put(
    //   `merchant-terminals/${id}/themes`,
    //   {
    //     themeId,
    //   },
    //   { params: { active: true } }
    // );

    return result.data;
  },

  async deleteTheme({ id, themeId }: IDeleteThemePayload): Promise<IActiveTheme> {
    const result = await axiosInstance.delete(
      `customizations/merchants/terminals/${id}/themes/${themeId}`,
    );
    // const result = await customizationInstance.delete(
    //   `merchant-terminals/${id}/themes/${themeId}`
    // );
    return normalizeActiveTheme(result.data);
  },

  async getGoogleFonts(): Promise<IGoogleFont[]> {
    const result = await googleFontsAxiosInstance.get('google-fonts-v2.json');
    return Object.entries<TObject>(result.data).map(([key, value]) =>
      normalizeGoogleFont(key, value),
    );
  },
};

export default merchantTerminalThemesAPI;
